
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import store from '@/store/index';
import { addOddToCartV3FromSport } from '@/composables/useOdds';
import IllinoisCounter from './Counter.vue';

@Component({
  components: { IllinoisCounter }
})
export default class QuckBetItem extends Vue {
  @Prop({ type: String, required: true }) readonly sportId!: string;
  @Prop({ type: String, required: true }) readonly categoryId!: string;
  @Prop({ type: String, required: true }) readonly tournamentId!: string;
  @Prop({ type: String, required: false, default: '' })
  readonly backgroundUrl!: string;

  isOpen: boolean = false;
  requestedCount: number = 1;

  get bgStyle() {
    return this.backgroundUrl
      ? {
          backgroundImage: `url(${this.backgroundUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      : {};
  }

  openModal() {
    this.isOpen = true;
    this.$nextTick(() => {
      const el = this.$refs.numInput as HTMLInputElement | undefined;
      if (el) el.focus();
    });
    // Trigger fetch degli eventi del torneo se assenti
    this.ensureTournamentEvents();
  }

  closeModal() {
    this.isOpen = false;
  }

  async ensureTournamentEvents() {
    try {
      await store.dispatch('IllinoisSport/fetchEventsByTournament', {
        sportId: this.sportId,
        categoryId: this.categoryId,
        tournamentId: this.tournamentId
      });
    } catch (e) {
      // silenzioso: lo store evita doppie fetch
    }
  }

  async confirm() {
    this.$store.dispatch('cart/resetCart');
    const n = Math.max(1, Number(this.requestedCount || 1));
    const tournamentKey = String(this.tournamentId);
    const groups = (store.getters['IllinoisSport/getAllEventsByTournament'] ||
      store.state.IllinoisSport.eventsByTournament) as any;
    const grouped =
      groups && groups[tournamentKey] ? groups[tournamentKey] : [];
    const allEvents = Array.isArray(grouped)
      ? grouped.flatMap((g: any) => (Array.isArray(g.events) ? g.events : []))
      : [];

    if (!allEvents.length) {
      this.closeModal();
      return;
    }

    const pickedEvents = this.pickRandom(allEvents, n);

    for (const ev of pickedEvents) {
      const oddsList = Array.isArray(ev?.odds) ? ev.odds : [];
      if (!oddsList.length) continue;
      const market = oddsList[Math.floor(Math.random() * oddsList.length)];
      const outcomes = Array.isArray(market?.outcome) ? market.outcome : [];
      if (!outcomes.length) continue;
      const outcome = outcomes[Math.floor(Math.random() * outcomes.length)];

      try {
        await addOddToCartV3FromSport({
          eventId: ev.id,
          outcomeUniqueId: outcome.unique_id,
          sportId: this.sportId,
          sportName: String(ev?.sportName || ''),
          categoryId: this.categoryId,
          categoryName: String(ev?.categoryName || ''),
          tournamentId: this.tournamentId,
          tournamentName: String(ev?.tournamentName || ''),
          marketId: String(market?.unique_id || market?.id)
        });
      } catch (err) {
        // continua sugli altri eventi
      }
    }

    this.closeModal();
    this.$store.dispatch('cart/setIsCartOpen', true);
  }

  pickRandom<T>(arr: T[], count: number): T[] {
    const max = Math.min(count, arr.length);
    const copy = arr.slice();
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, max);
  }

  t(key: string) {
    return this.$t(key);
  }
}
